import React from 'react';
import { useParams } from 'react-router-dom';
import ContentCard from '../Layouts/ContentCard';
import { FaRegObjectGroup } from "react-icons/fa6";
import Breadcrumbs from '../Components/Breadcrumbs/Breadcrumbs';
import { useFetchImageQuery } from '../api/image';
import ResultList from '../Components/Result/ResultList';
import LoadingSpiner from '../Components/Loader/LoadingSpiner';
import ResultActionButtons from '../Components/Result/ResultActionButtons';
import ImageTitleEditor from '../Components/Image/ImageTitleEditor';
import StarToggle from '../Components/Favorite/StarToggle';
import convertS3UrlToHttps from '../utils/convertS3UrlToHttps';
import placeholderImage from '../Components/Result/assets/empty-result-placeholder.png';

export default function ImagePage() {
    const { imageId } = useParams();
    const { data: imageData, isLoading: isImageLoading, isError: isImageError } = useFetchImageQuery(imageId);

    if (isImageLoading) return <div><LoadingSpiner/></div>;
    if (isImageError) return <div>Error fetching image or results</div>;

    const { name, description, image_urls, thumbnail_url } = imageData; // Adjust these according to the structure of your image data

    return (
        <div className="container mx-auto">
            <div className="grid grid-cols-1 gap-4 mt-4">
                <div className="flex items-center">
                    {/* the thumbnail key is written to DynamoDB before the file is
                        uploaded, so it 404s while tiling is still in progress */}
                    <img
                        src={thumbnail_url ? convertS3UrlToHttps(thumbnail_url) : placeholderImage}
                        alt={name}
                        onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = placeholderImage; }}
                        className="w-24 h-24 object-fit rounded mr-4"
                    />
                    <div>
                        <div className="flex items-center">
                            <ImageTitleEditor key={imageId} name={name} id={imageId || ''} />
                            <StarToggle entityId={imageId || ''} entityType="Image" className="ml-2" />
                        </div>
                        <p className="text-gray-600">{description}</p>
                    </div>
                </div>
            </div>
            <Breadcrumbs />
            <ResultActionButtons imageId={imageId}/>
            <ContentCard className="mx-0 pb-24" title="">
                <ResultList imageId={imageId || ''} thumbnail_url={thumbnail_url}/>
            </ContentCard>
        </div>
    );
}
